/*
 * Text and formatting helpers shared by the agent tools. Relative cc-lib
 * imports (not @cclib) so the tools also load under plain `node --test`.
 */

import convertToPlainText from "../../../external/cc-lib/dist/functions/quill/convertToPlainText.js";
import convertToPlainTextCustom from "../../../external/cc-lib/dist/functions/quill/convertToPlainTextCustom.js";
import convertToHtml from "../../../external/cc-lib/dist/functions/quill/convertToHtml.js";

export const MAX_RESULT_EVENTS = 200;
export const MAX_RESULT_CHARS = 30000;

export function toPlain(html) {
    return convertToPlainText(html || "");
}

/** Event text as plain lines, keeping bold/italic/underline as <b>/<i>/<u>. */
export function toMarkup(html) {
    if (!html) return "";
    return convertToPlainTextCustom(html, "\n", false, "b", "i", "u");
}

/**
 * Plain text (lines separated by \n, optional <b>/<i>/<u>) to event HTML,
 * keeping the paragraph alignment classes of the event's current text.
 */
export function markupToHtml(text, previousHtml = "") {
    // Model text can echo prompt-injected subtitle content. convertToHtml keeps
    // its formatting tags verbatim, attributes included, and event text is
    // rendered with {@html} (Node integration is on in Electron), so reduce
    // every tag to its bare name first: <b onmouseover=…> becomes <b>.
    const value = String(text ?? "")
        .replace(/\r\n?/g, "\n")
        .replace(/<\s*(\/?)\s*([A-Za-z][\w-]*)\b[^>]*>/g, "<$1$2>")
        .trim();
    if (!value) return "";
    const classMatch = /<p\s+class="([^"]*)"/i.exec(previousHtml || "");
    const classNames = classMatch ? classMatch[1].split(/\s+/).filter(Boolean) : null;
    return convertToHtml(value, classNames && classNames.length ? classNames : null);
}

/** Keep event text from closing or opening our delimiter tags. */
export function escapeDelimiters(text) {
    return String(text ?? "").replace(/<(\/?)event_text\b[^>]*>/gi, "‹$1event_text›");
}

export function wrapEventText(text) {
    return `<event_text>${escapeDelimiters(text)}</event_text>`;
}

export function roundTime(seconds) {
    return Number.isFinite(seconds) ? Math.round(seconds * 1000) / 1000 : null;
}

export function clip(text, max) {
    const value = String(text ?? "");
    return value.length > max ? value.slice(0, max) + "…" : value;
}
